import React from 'react';
import I18n from 'i18n-js';
import SessionPopup from '@/components/common/SessionPopup';

interface Props {
  dismissOnly?: boolean;
  isOpen: boolean;
  onJoinClick?: () => void;
}

// AIDEV-NOTE: Non-dismissable (no onClose). Join is disabled until the parent supplies onJoinClick.
// PLAT-17536 — dismissOnly relabels the button "Close" (parent just closes; no navigation).
const TeachingSessionStartedPopup = ({ dismissOnly = false, isOpen, onJoinClick }: Props) => (
  <SessionPopup
    body={I18n.t('teaching_session_started_body')}
    headline={{
      id: 'teaching-session-started-headline',
      text: I18n.t('teaching_session_started_headline'),
    }}
    isOpen={isOpen}
    primaryButton={{
      disabled: !onJoinClick,
      onClick: onJoinClick,
      text: I18n.t(dismissOnly ? 'close' : 'teaching_session_join_button'),
    }}
  />
);

export default TeachingSessionStartedPopup;
